export default __webpack_public_path__ + "static/signupBackground-98d2d1b44ffc6a3486f0b3fa030e3496.jpg";